import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_sc29dnj3dh: FaireBrandEntity = {
  token: "b_sc29dnj3dh",
  type: "brand",
  name: "Fabuplates",
  avatarUrl:
    "https://cdn.faire.com/fastly/b351712d0e76719dc594cf253c5f41da56d497e5f3c0550ee4b7742a4246a5d9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ee9b3ebfd7e097bb6bef9eac7b4731145f04bccd73c10f1e094075724e168f59.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b351712d0e76719dc594cf253c5f41da56d497e5f3c0550ee4b7742a4246a5d9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ee9b3ebfd7e097bb6bef9eac7b4731145f04bccd73c10f1e094075724e168f59.jpeg",
  location: "Houston, TX, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 18,
  isTopShop: true,
  isInsider: true,
  description:
    "Fabuplates is redefining disposable tableware for the modern retailer. Founded in 2023, our brand delivers a fresh, elevated approach to paper plates and napkins—pairing artful design with exceptional quality your customers can see and feel.\n\nEach product is part of a meticulously curated collection or available as separates, giving stores the flexibility to merchandise by theme, season, or aesthetic. From vibrant florals to playful patterns, Fabuplates makes it easy for retailers to offer customers entertaining essentials that feel festive, refined, and gift-worthy.\n\nFounder Maggie brings over 15 years of wholesale and product development experience to the table, having previously worked with top-tier retailers through her work at Kitty Keller Designs. With that insight, Fabuplates was built to serve today’s retail environment—offering strong margins, standout shelf appeal, and even custom design capabilities for private label and branded collaborations.\n\nWhether your customers are planning elegant events or seeking charming everyday paper goods, Fabuplates turns disposable into desirable.\n\nUpscale. Eye-catching. No clean-up required.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:55.822Z",
    importedBy: "entity-db-cli",
  },
};
